var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import Select from "react-select";
import styled from "styled-components";
var SelectWithClassName = function (props) {
    return React.createElement(Select, __assign({ classNamePrefix: "gwselect" }, props));
};
export var InputSelect = styled(SelectWithClassName)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: block;\n  font-size: 1.4rem;\n  > span {\n    padding-top: 2px;\n  }\n  .gwselect__control {\n    border: 1px solid ", ";\n    border-radius: ", ";\n    color: ", ";\n    &.gwselect__control--is-focused,\n    &.gwselect__control--is-focused.gwselect__control--is-open {\n      border: 1px solid ", ";\n      border-radius: ", ";\n      color: ", ";\n    }\n    &:hover {\n      border: 1px solid ", ";\n    }\n  }\n  .gwselect__value-container {\n    > div {\n      color: ", ";\n    }\n  }\n  .gwselect__indicator-separator {\n    background-color: ", ";\n  }\n  .gwselect__indicator {\n    > svg {\n      fill: ", ";\n    }\n  }\n\n  &.small {\n    font-size: 1.2rem;\n    .gwselect__control {\n      min-height: 32px;\n    }\n    .gwselect__value-container {\n      padding: 0px 8px;\n    }\n    .gwselect__indicator {\n      padding: 4px;\n    }\n  }\n"], ["\n  display: block;\n  font-size: 1.4rem;\n  > span {\n    padding-top: 2px;\n  }\n  .gwselect__control {\n    border: 1px solid ", ";\n    border-radius: ", ";\n    color: ", ";\n    &.gwselect__control--is-focused,\n    &.gwselect__control--is-focused.gwselect__control--is-open {\n      border: 1px solid ", ";\n      border-radius: ", ";\n      color: ", ";\n    }\n    &:hover {\n      border: 1px solid ", ";\n    }\n  }\n  .gwselect__value-container {\n    > div {\n      color: ", ";\n    }\n  }\n  .gwselect__indicator-separator {\n    background-color: ", ";\n  }\n  .gwselect__indicator {\n    > svg {\n      fill: ", ";\n    }\n  }\n\n  &.small {\n    font-size: 1.2rem;\n    .gwselect__control {\n      min-height: 32px;\n    }\n    .gwselect__value-container {\n      padding: 0px 8px;\n    }\n    .gwselect__indicator {\n      padding: 4px;\n    }\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.gwThemed.inputs.main.borderColor;
}, function (_a) {
    var theme = _a.theme;
    return theme.borders.radius;
}, function (_a) {
    var theme = _a.theme;
    return theme.gwThemed.inputs.main.color;
}, function (_a) {
    var theme = _a.theme;
    return theme.gwThemed.inputs.main.borderColor;
}, function (_a) {
    var theme = _a.theme;
    return theme.borders.radius;
}, function (_a) {
    var theme = _a.theme;
    return theme.gwThemed.inputs.main.color;
}, function (_a) {
    var theme = _a.theme;
    return theme.gwThemed.inputs.main.borderColor;
}, function (_a) {
    var theme = _a.theme;
    return theme.gwThemed.inputs.main.color;
}, function (_a) {
    var theme = _a.theme;
    return theme.gwThemed.inputs.main.borderColor;
}, function (_a) {
    var theme = _a.theme;
    return theme.gwThemed.inputs.main.borderColor;
});
var templateObject_1;
//# sourceMappingURL=InputSelect.js.map